import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getPersonsByStartName(startName, source) {
    const response = await axios.get(
      `/api/autocomplete/${source}/${startName}`
    );
    return response.data;
  },
};
